import Backbone from "backbone";
import $ from "jquery";
import ConsumerTokenModel from "src/profiles/view/ConsumerTokenModel";

const MeAssetModel = Backbone.Model.extend({
    initialize(attributes, options) {
        this.defaultDomain = options.defaultDomain;
        this.email = options.email;
        this.assetId = options.assetId;
        this.tokenModel = new ConsumerTokenModel(null, {
            defaultDomain: this.defaultDomain,
            email: this.email,
        });
    },

    fetchAsset() {
        const self = this;
        return new Promise((resolve, reject) => {
            self.tokenModel.save().done(() => {
                const token = self.tokenModel.get("access_token");
                const url = new URL(
                    `/api/v4/me/assets/${self.assetId}`,
                    `https://${self.defaultDomain}`
                );
                $.ajax({
                    url: url.toString(),
                    method: "GET",
                    headers: {
                        Authorization: token,
                    },
                    success(response) {
                        self.set(response);
                        resolve(response);
                    },
                    error: reject,
                });
            });
        });
    },
});

export default MeAssetModel;
